import type { ObjectId } from "@bbj-types/utils";
import { useSuspense } from "@root/api/tools/axios";
import { useCallback } from "react";
import { diagnosisAxiosInstance, useAxiosDiagnosis } from "./axios";
import type { IDiagnosis } from "./types";

export interface IGetDiagnosis extends Omit<IDiagnosis, "externalIntegrations"> {}

export const useGetDiagnosis = () => {
  const [state, execute, cancel] = useAxiosDiagnosis<IGetDiagnosis>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (diagnosisId: ObjectId) =>
      execute({
        url: `/${diagnosisId}`,
      }),
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useGetDiagnosisSuspense = (diagnosisId: ObjectId) =>
  useSuspense(
    () => diagnosisAxiosInstance.get<IGetDiagnosis>(`/${diagnosisId}`, { withCredentials: true }),
    [diagnosisId]
  );
